import axios from "axios";
import store from "@/store/index";
import { axiosUrl } from "@/environment";
import router from "@/router/index";

import { Message } from "element-ui";
import { Notification } from "element-ui";
// import { Loading } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 导入NProgress进度条插件
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// let loadingInstance: any;

// 创建axios，赋给变量service
const service = axios.create({
  baseURL: axiosUrl,
  // 设置超时时间
  timeout: 60000,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器  请求接口前做一些数据处理
service.interceptors.request.use((config: any) => {
  NProgress.start();
  // loadingInstance = Loading.service({ fullscreen: true });
  if (store.state.token) {
    config.headers.token = store.state.token;
  }
  // X-ReqID为唯一请求ID，方便定位问题，值为纳秒时间戳
  config.headers['X-ReqID'] = performance.now()
  return config;
}),
  (error: Error) => {
    NProgress.done();
    // 以服务的方式调用的 Loading 需要异步关闭
    // loadingInstance.close();
    console.log(`请求错误：${error}`);
    Promise.reject(error.message);
  };

// 响应拦截器   请求接口返回数据后进行拦截
service.interceptors.response.use(
  (response: any) => {
    // if (response.status !== 200) {
    //   Message({
    //     message: `${response.data.message}`,
    //     type: "error",
    //   });
    //   return Promise.reject("服务链接失败");
    // }
    NProgress.done();
    // loadingInstance.close();
    switch (response.data.code) {
      case 200:
        return Promise.resolve(response);
      // case 400:
      //   return Promise.reject(new Error("查询参数错误"));
      case 401:
      case 402:
      case 4003:
      case 40101:
        if (window.sessionStorage.getItem("isExpired") === "0") {
          Message({
            message: "登录状态过期，请重新登录！",
            type: "error",
          });
          window.sessionStorage.removeItem("token");
          store.dispatch("setToken", {
            token: "",
          });
          setTimeout(() => {
            router.go(0);
          }, 500);
        }
        window.sessionStorage.setItem("isExpired", "1");
        window.sessionStorage.removeItem("token");
        store.dispatch("setToken", {
          token: "",
        });
        return Promise.reject(new Error("登录状态过期"));
      // case 403:
      //   return Promise.reject(new Error("无权限"));
      // case 404:
      //   return Promise.reject(new Error("用户不存在"));
      // case 405:
      //   return Promise.reject(new Error("用户已禁用"));
      case 40001:
        Message({
          message: "请求错误，您有必填字段未填写",
          type: "error",
        });
        return Promise.reject(new Error("请求错误，必填字段为空"));
      case 500:
        Message({
          message: "服务未知错误，请刷新页面或稍后重试！",
          type: "error",
        });
        return Promise.reject(new Error("服务未知错误"));
      case 5001:
        Notification({
          title: "保存并下一步操作失败",
          message: `${response.data.message || response.data.msg}`,
          type: "error",
          // duration: 6000,
        });
        return Promise.reject(new Error("手机号或证件号被占用"));
      case 5002:
        Message({
          message: `${response.data.message || response.data.msg} || "服务内部出错，数据操作错误"`,
          type: "error",
        });
        return Promise.reject(new Error("数据操作错误"));
      case 503:
      case 5003:
        Message({
          message: "服务内部出错，请刷新页面或稍后重试！",
          type: "error",
        });
        return Promise.reject(new Error("服务内部错误"));
      default:
        Message({
          message: `${response.data.message || response.data.msg}`,
          type: "error",
        });
        return Promise.reject(new Error("服务未知错误"));
    }
  },
  (error: any) => {
    NProgress.done();
    // loadingInstance.close();
    console.log(error);
    Message({
      message: `响应错误：${error.response.statusText}`,
      type: "error",
    });
    return Promise.reject(error.message);
  }
);

export default service;
